import React from "react";
import Navigationbar from "../Components/Navbar/Navbar";
import Objectives from "../Components/Objectives/Objectives";
import Objectives2 from "../Components/Objectives2/Objectives";
import Footer from "../Components/Footer/Footer";
import Hives from "../Components/Hives/Hives";

function Vision() {
  return (
    <>
      <Navigationbar />
      {/* <Objectives /> */}
      <Objectives2 />
      <Hives />
      <Footer />
    </>
  );
}

export default Vision;
